import React, {FC} from 'react';

// Placeholder MTN mark (yellow oval + wordmark). Swap for the official SVG from MTN's brand kit.
const MtnLogo: FC<{height?: number}> = ({height = 72}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 200 110"
    height={height}
    role="img"
    aria-label="MTN">
    <ellipse cx="100" cy="55" rx="96" ry="51" fill="#FFCB05" />
    <ellipse
      cx="100"
      cy="55"
      rx="80"
      ry="38"
      fill="none"
      stroke="#000"
      strokeWidth="5"
    />
    <text
      x="100"
      y="70"
      textAnchor="middle"
      fontFamily="Arial Black, Arial, sans-serif"
      fontWeight="900"
      fontSize="42"
      fill="#000">
      MTN
    </text>
  </svg>
);

export default MtnLogo;
